/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { AutomatedProcessParameterBaseDto } from '../../models/automated-process-parameter-base-dto';

export interface AutomatedProcessGetAllAutomatedProcessParameters$Params {
}

export function automatedProcessGetAllAutomatedProcessParameters(http: HttpClient, rootUrl: string, params?: AutomatedProcessGetAllAutomatedProcessParameters$Params|null|undefined, context?: HttpContext): Observable<StrictHttpResponse<Array<AutomatedProcessParameterBaseDto>>> {
  const rb = new RequestBuilder(rootUrl, automatedProcessGetAllAutomatedProcessParameters.PATH, 'get');
  if (params) {
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<Array<AutomatedProcessParameterBaseDto>>;
    })
  );
}

automatedProcessGetAllAutomatedProcessParameters.PATH = '/automated-process/parameter';